import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AtSign";
const AtSign = memo(themed(Icon));
export {
  AtSign
};
//# sourceMappingURL=at-sign.js.map
